import { render } from "./OpenOrders.vue?vue&type=template&id=5746fa30&scoped=true"
import script from "./OpenOrders.vue?vue&type=script&lang=js"
export * from "./OpenOrders.vue?vue&type=script&lang=js"

import "./OpenOrders.vue?vue&type=style&index=0&id=5746fa30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5746fa30"]])

export default __exports__